/**
 * 
 * @author Jesus R. Nava Cruz
 * @date May 26, 2023
 * @version 1.0
 * 
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";

export default class PhysicalSpacesService extends MainService {

    static listAllPagination(params) {
        return this.postSEC(ServiceConstant.PHYSICAL_SPACES_LIST_ALL_PAGINATION, params);
    }

    static listAll() {
        return this.postSEC(ServiceConstant.PHYSICAL_SPACES_LIST_ALL);
    }

    static add(params) {
        return this.postSEC(ServiceConstant.PHYSICAL_SPACES_ADD, params);
    }

    static get(params) {
        return this.postSEC(ServiceConstant.PHYSICAL_SPACES_GET, {idProduct: params.idMedicalPractice.idProduct});
    }

    static update(params) {
        return this.postSEC(ServiceConstant.PHYSICAL_SPACES_UPDATE, params);   
    }

    static delete(params) {
        return this.postSEC(ServiceConstant.PHYSICAL_SPACES_DELETE, params);
    }

}
